import React, {useState, useRef, useEffect} from 'react';
import TeamColumn from './TeamColumn.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function Team() 
{
    const { app_user, team_id, team, setTeam, setTeamReady, team_display_refresh, setTeamDisplayRefresh,
            setTeamMembersList, setTeamInvitationsList, setTeamOutsideInvitationsList, setTeamJoinRequestsList,
            setTeamTags, setTeamShortTermGoals, setTeamHistoryEvents, setTeamTransactions, team_short_term_goals} = useCTAL();

    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const fetchRef = useRef("");

    if ((DEBUG) && (team_id)) console.log(`Team** - UserID from Context: ${app_user.UserID}, TeamID from Context: ${team.TeamID}`);

    const set_team_and_members = async (items) => { 
        if (DEBUG) console.log(`Team**** - num team_items: ${items.length}`);

        var team_items = items.filter( item => { return (item.Type === "Team"); } );
        if (team_items.length != 1) return;

        await setTeam(team_items[0]);
        await setTeamMembersList(items.filter( item => { return ((item.Type === "Member") && ((item.TeamRole === "Member") || (item.TeamRole === "Admin"))); } ));
        await setTeamInvitationsList(items.filter( item => { return ((item.Type === "Member") && (item.TeamRole === "Team-Invitation")); } ));
        await setTeamOutsideInvitationsList(items.filter( item => { return (item.Type === "Outside-Invitation"); } ));
        await setTeamJoinRequestsList(items.filter( item => { return ((item.Type === "Member") && (item.TeamRole === "Member-Join-Request")); } ));
        await setTeamTags(items.filter( item => { return (item.Type === "Tag"); } ));       
        await setTeamHistoryEvents(items.filter( item => { return (item.Type === "History Event"); } ));
        await setTeamTransactions(items.filter( item => { return ((item.Type === "Bill") || (item.Type === "Payment") || (item.Type === "Credit")); } ));

        var stgs = items.filter( item => { return (item.Type === "Short-Term-Goal") } );
        await setTeamShortTermGoals(stgs.reverse());

        setTeamReady(true); //let's try and keep components from updating until the team has finished loading

        if (DEBUG) console.log(`Team**** - setTeam: ${team_items[0].TeamName}`);
    }

    useEffect(() =>
    {
        if (!team_id) return;
        
        var type = "get_team_all";
        var user_id = app_user.UserID;
        var search_body = JSON.stringify({type, team_id, user_id});
    
        if ((fetchRef.id == team_id) && (!team_display_refresh)) return;
        fetchRef.id = team_id;
        
        setTeamReady(false); //let's try and keep components from updating until the team has finished loading
        setTeamDisplayRefresh(false);

        console.log(`Team - fetching Team (bulk) from ctal-get for: ${team_id}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-get`, { method: "POST", body: search_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: search_body })
            .then(response => response.json())
            .then(set_team_and_members)
            .then(() => setLoading(false))
            .catch(setError);
    }, [team_id,  team_display_refresh]);
    
    if (loading) return <h1>Loading Team...</h1>;
    if (error) return <pre>{JSON.stringify(error, null, 2)}</pre>
    if (!team) return null;
      
    if (DEBUG) { console.log(`Team - TeamName: ${team.TeamName}, UserID: ${app_user.UserID}`); return; }

    return ( <> <TeamColumn /> </> );
}